import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-http-re-quest-loader',
  templateUrl: './http-re-quest-loader.component.html',
  styleUrls: ['./http-re-quest-loader.component.css']
})
export class HttpReQuestLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
